module.exports = __webpack_public_path__ + "img/chancesleet.fdae2848.png";